// Import modules
import mobileMenu from "./modules/mobile-menu.js";
import modal from "./modules/modal.js";
import notification from "./modules/notification.js";
import accordion from "./modules/accordion.js";
import swipers from "./modules/swipers.js";
import nameWriter from "./modules/name-writer.js";
import jobFinder from "./modules/job-finder.js";
import { Fancybox } from "@fancyapps/ui";
import Isotope from "isotope-layout";

// Init functions
function init() {
  // init fancybox
  Fancybox.bind("[data-fancybox]");

  // init mobile menu --> wp-content/themes/expl-theme/source/scripts/modules/mobile-menu.js
  mobileMenu();

  accordion('[data-list="accordion"]');

  // init modal --> wp-content/themes/expl-theme/source/scripts/modules/modal.js
  modal();

  nameWriter();

  jobFinder();

  swipers();

  document.querySelectorAll(".gfield.read-only input").forEach(function (el) {
    el.setAttribute("readonly", "");
  });

  // init notification --> wp-content/themes/expl-theme/source/scripts/modules/notification.js
  // init notification popup
  document.querySelector(".notification-popup") && notification(".notification-popup", "notification-popup", 1000);

  // init notification snackbar
  document.querySelector(".notification-snackbar") && notification(".notification-snackbar", "notification-snackbar", 2000);

  // filters dropdown toggle
  document.querySelectorAll('[data-sf-field-type~="taxonomy"] > h4').forEach(function (header) {
    header.addEventListener("click", function (e) {
      // Toggle 'active' class on the parent element of the clicked header
      this.parentElement.classList.toggle("active");

      // Prevent the default action of the event (similar to `return false` in jQuery)
      e.preventDefault();
    });
  });

  // init isotope
  const grid = document.querySelector(".items-list-maetstaf");

  const iso =
    grid != null &&
    new Isotope(grid, {
      itemSelector: ".item",
      masonry: {
        gutter: 16,
      },
      percentPosition: true,
    });
}

// Run the init function when the page loads
window.onload = init;
